module.exports = require("@embedpdf/plugin-search/react");